import { createApi } from '@/api'
export default {
  serverTypeList: config => createApi(`/serviceProductType/getList`, 'get', config), // 农产品类型列表
  addServerType: config => createApi(`/serviceProductType/add`, 'post', config), // 农产品类型添加
  deleteServerType: config => createApi(`/serviceProductType/delete`, 'delete', config), // 农产品类型删除
  updateServerType: config => createApi(`/serviceProductType/update`, 'post', config), // 农产品类型修改
  serverTypeDetail: config => createApi(`/serviceProductType/get`, 'get', config) // 农产品类型详情
}



// WEBPACK FOOTER //
// ./src/views/serverTypeManage/api/index.js